export default {
  eyebrow: 'Partnerportal',
  title: 'Steuern & Währung',
  description:
    'Standard-Steuerkategorien, die Ihre Restaurants übernehmen, sofern sie eine Kategorie nicht individuell überschreiben.',
};
